up.error = (function () {
    function fail(...args) {
        throw new up.Error(args);
    }
    function isCritical(error) {
        return (typeof error !== 'object') || ((error.name !== 'AbortError') && !(error instanceof up.RenderResult) && !(error instanceof up.Response));
    }
    function muteUncriticalRejection(promise) {
        return promise.catch(throwCritical);
    }
    function muteUncriticalSync(block) {
        try {
            return block();
        }
        catch (e) {
            throwCritical(e);
        }
    }
    function throwCritical(value) {
        if (isCritical(value)) {
            throw value;
        }
    }
    function guard(fn, ...args) {
        try {
            return fn(...args);
        }
        catch (error) {
            reportError(error);
        }
    }
    function guardPromise(promise) {
        return promise.catch(reportError);
    }
    function guardFn(fn) {
        if (fn) {
            return (...args) => guard(() => fn(...args));
        }
    }
    return {
        fail,
        throwCritical,
        muteUncriticalRejection,
        muteUncriticalSync,
        guard,
        guardPromise,
        guardFn,
    };
})();
up.fail = up.error.fail;
